// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__1zQv+","tyre":"style_tyre__-gh3E"};